// [CurveBeam] - [BoneVue]

import React, { useEffect, useState } from 'react';
import { BmdService } from '@ohif/core';
import { ScanDetail } from '@ohif/core/src/services/BmdService/models/scan.interface';

interface IBmdContext {
  bmdService?: BmdService;
  scanDetail?: ScanDetail;
  apiLoading?: boolean;
  initializing?: boolean;
}

export const BmdContext = React.createContext<IBmdContext>({});

interface Props {
  children?: JSX.Element;
  services: {
    bmdService: BmdService;
  };
}

export const BmdContextProvider: React.FunctionComponent<Props> = ({
  children,
  services,
}) => {
  const { bmdService } = services;

  const [scanDetail, setScanDetail] = useState<ScanDetail>(
    bmdService.scanDetail
  );
  const [apiLoading, setApiLoading] = useState(bmdService.apiLoading);
  const [initializing, setInitializing] = useState(bmdService.initializing);

  // - Subscribe to the changes
  useEffect(() => {
    bmdService.scanDetailUpdated = (scanDetail: ScanDetail) => {
      setScanDetail(scanDetail);
    };

    bmdService.apiLoadingUpdated = (loading: boolean) => {
      setApiLoading(loading);
    };

    bmdService.initializingUpdated = (loading: boolean) => {
      setInitializing(loading);
    };
  }, [bmdService]);

  return (
    <BmdContext.Provider
      value={{
        bmdService,
        scanDetail,
        apiLoading,
        initializing,
      }}
    >
      {children}
    </BmdContext.Provider>
  );
};
